<div class="container-fluid h-100 px-4 py-2 d-flex flex-column justify-content-between">

  <div>
    <div>
      <div class="row align-items-end my-2">
        <button for="attach-button" class="px-3 py-3 rounded-3 d-flex align-items-center gap-2"
          *ngIf="dataService.role == 'doctor'" style="border:1px dashed #898989" (click)="scanFile.click()">
          <input hidden multiple (change)="addFileDetails($event)" #scanFile type="file" id="scanFile">
          <div class="rounded-circle customPreActivatedButtons p-1" style="height:30px;width: 30px;max-width: 100px;">
            <i class="fa fa-plus"></i>
          </div>
          <span style="color:#205567;">
            Scan Files
          </span>
        </button>
      </div>
      <div class="row align-items-end mb-2" *ngIf="fileDetailsScan.length > 0">
        <div class="col text-start" style="color:#205567;">Scan Files</div>
      </div>
      <ul class="list-group mb-2 border p-3 py-1" *ngIf="fileDetailsScan.length > 0">
        <li class="py-1 list-group-item px-0 lastDeleteOne" *ngFor="let file of fileDetailsScan">
          <div class="d-flex justify-content-between align-items-center gap-3">
            <div class="text-truncate" style="color:#205567;">
              {{file.fileName}}
            </div>
            <div class="d-flex gap-1 align-items-center">
              <div style="color: #205567;" (click)="removeFileDetails(file.fileId)"
                *ngIf="dataService.role == 'doctor'">
                <i class="fa fa-trash"></i>
              </div>
              &nbsp;
              <div style="color: #205567;" (click)="downloadFile(file.fileId, file.fileName)">
                <i class="fa-solid fa-arrow-down"></i>
              </div>
            </div>
          </div>
          <hr class="m-0 mt-2 p-0">
        </li>
      </ul>
    </div>

    <div>
      <div class="row align-items-end mb-2 mt-5">
        <button for="attach-button" class="px-3 py-3 rounded-3 d-flex align-items-center gap-2"
          *ngIf="dataService.role == 'doctor'" style="border:1px dashed #898989" (click)="imagesFile.click()">
          <input hidden multiple (change)="addFileDetails($event, 'images')" #imagesFile type="file" id="imagesFile">
          <div class="rounded-circle customPreActivatedButtons p-1" style="height:30px;width: 30px;max-width: 100px;">
            <i class="fa fa-plus"></i>
          </div>
          <span style="color:#205567;">
            Scan Images or Sketches
          </span>
        </button>
      </div>
      <ul class="list-group mb-2">
        <li class="py-1 list-group-item d-flex justify-content-between align-items-center gap-3"
          *ngFor="let file of fileDetailsImages">
          <span style="color:#205567;" class="text-truncate">
            {{file.fileName}}
          </span>
          <div class="d-flex gap-1 align-items-center">
            <div style="color: #205567;" (click)="removeFileDetails(file.fileId)" *ngIf="dataService.role == 'doctor'">
              <i class="fa fa-trash" style="color:#205567;"></i>
            </div>
            &nbsp;
            <div style="color: #205567;" (click)="downloadFile(file.fileId, file.fileName)">
              <i class="fa-solid fa-arrow-down" style="color:#205567;"></i>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div *ngIf="fileDetailsOrderForm.length > 0">
      <div class="row align-items-end mb-2">
        <div class="col text-start" style="color:#205567;">Order Forms</div>
        <!-- <div class="col text-end">
          <button mat-mini-fab color="primary" (click)="customFile.click()"><mat-icon>upload</mat-icon></button>
          <input hidden multiple (change)="addFileDetails($event)" #customFile type="file" id="customFile">
        </div> -->
      </div>
      <ul class="list-group mb-2 border p-3 py-1">
        <li class="py-1 list-group-item px-0 lastDeleteOne " *ngFor="let file of fileDetailsOrderForm">
          <div class="d-flex justify-content-between align-items-center gap-3">
            <span style="color:#205567;" class="text-truncate">
              {{file.fileName}}
            </span>
            <span (click)="downloadFile(file.fileId, file.fileName)">
              <!-- <span (click)="callParentDownload()"> -->
              <i class="fa-solid fa-arrow-down" style="color:#205567;"></i>
            </span>
          </div>
          <hr class="m-0 mt-2 p-0">
        </li>
      </ul>

    </div>

    <!-- <div *ngIf="fileDetailsDesign.length > 0 || dataService.role == 'designer'">
      <div class="row align-items-end mb-2">
        <div class="col text-start" style="color: #205567;">Design Files</div>
        <div class="col text-end" *ngIf="dataService.role == 'designer'">
          <button mat-mini-fab color="primary" (click)="imagesFile.click()"><mat-icon>upload</mat-icon></button>
          <input hidden multiple (change)="addFileDetails($event, 'design')" #imagesFile type="file" id="imagesFile">
        </div>
      </div>
      <ul class="list-group">
        <li class="py-0 list-group-item d-flex justify-content-between align-items-center gap-2" *ngFor="let file of fileDetailsDesign">
          <span style="color:#205567;"class="text-truncate">
            {{file.fileName}}
          </span>
          <div>
            <button class="customPreActivatedButtons" (click)="removeFileDetails(file.fileId)" *ngIf="dataService.role == 'designer'">
              <i class="fa fa-trash" style="color: #205567;"></i>
            </button>
            &nbsp;
            <button class="customPreActivatedButtons" (click)="downloadFile(file.fileId, file.fileName)">
              <i class="fa fa-download" style="color: #205567;"></i>
            </button>
          </div>
        </li>
      </ul>
      <hr>
    </div> -->

    <!-- <div *ngIf="fileDetails3dVisualisation.length > 0 || dataService.role == 'designer'">
      <div class="row align-items-end mb-2">
        <div class="col text-start">3D Visalisation files</div>
        <div class="col text-end" *ngIf="dataService.role == 'designer'">
          <button mat-mini-fab color="primary" (click)="imagesFile.click()"><mat-icon>upload</mat-icon></button>
          <input hidden multiple (change)="addFileDetails($event, 'visual')" #imagesFile type="file" id="imagesFile">
        </div>
      </div>
      <ul class="list-group">
        <li class="py-0 list-group-item d-flex justify-content-between align-items-center gap-2" *ngFor="let file of fileDetails3dVisualisation">
          <div style="color: #205567;" class="text-truncate">
            {{file.fileName}}
          </div>
          <div>
            <button class="customPreActivatedButtons" (click)="removeFileDetails(file.fileId)" *ngIf="dataService.role == 'designer'">
              <i class="fa fa-trash" style="color: #205567;"></i>
            </button>
            &nbsp;
            <button class="customPreActivatedButtons" (click)="downloadFile(file.fileId, file.fileName)">
              <i class="fa fa-download" style="color: #205567;"></i>
            </button>
          </div>
        </li>
      </ul>
      <hr>
    </div> -->

    <!-- <div *ngIf="fileDetailsDesignImages.length > 0 || dataService.role == 'designer'">
      <div class="row align-items-end mb-2">
        <div class="col text-start">Design Images</div>
        <div class="col text-end" *ngIf="dataService.role == 'designer'">
          <button mat-mini-fab color="primary" (click)="imagesFile.click()"><mat-icon>upload</mat-icon></button>
          <input hidden multiple (change)="addFileDetails($event, 'designimages')" #imagesFile type="file" id="imagesFile">
        </div>
      </div>
      <ul class="list-group">
        <li class="py-0 list-group-item d-flex justify-content-between align-items-center gap-2" *ngFor="let file of fileDetailsDesignImages">
          <div class="text-truncate" style="color: #205567;">
            {{file.fileName}}
          </div>
          <div>
            <button class="customPreActivatedButtons" (click)="removeFileDetails(file.fileId)" *ngIf="dataService.role == 'designer'">
              <i class="fa fa-trash" style="color: #205567;"></i>
            </button>
            &nbsp;
            <button class="customPreActivatedButtons" (click)="downloadFile(file.fileId, file.fileName)">
              <i class="fa fa-download" style="color: #205567;"></i>
            </button>
          </div>
        </li>
      </ul>
      <hr>
    </div> -->

    <!-- <div *ngIf="fileDetailsCorrectedDesign.length > 0 || dataService.role == 'designer'">
      <div class="row align-items-end mb-2">
        <div class="col text-start">Corrected Design Files</div>
        <div class="col text-end">
          <button mat-mini-fab color="primary"><mat-icon>upload</mat-icon></button>
        </div>
      </div>
      <ul class="list-group">
        <li class="py-0 list-group-item d-flex justify-content-between align-items-center" *ngFor="let file of fileDetailsDesign">
          <div>
            {{file.fileName}}
          </div>
          <div><button mat-icon-button (click)="removeFileDetails(file.fileId)"><mat-icon>delete</mat-icon></button></div>
        </li>
      </ul>
      <hr>
    </div> -->

  </div>
  <div class="row mt-4 mb-3">
    <div class="col">
      <button class="customPreActivatedButtons" (click)="close()">Done</button>
    </div>
  </div>

</div>


<div class="spinner-overlay" *ngIf="dataService.progressBarActiveForSlider">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>


<!-- scan data, order forms, designs, and corrected designs  -->


<!-- <div class="card">
              <div class="card-header d-flex justify-content-between">
                  <div>Scan Files</div>
              </div>
              <ul class="list-group list-group-flush" *ngFor="let file of fileDetailsScan">
                  <li class="list-group item">
                      <div class="d-flex justify-content-between">
                          <div>{{file.fileName}}</div>
                          <div class="align-content-center">
                              <button *ngIf="dataService.role == 'doctor'" mat-icon-button (click)="removeFileDetails(file.fileId)"><mat-icon>delete</mat-icon></button>
                              &nbsp;
                              <button mat-icon-button (click)="downloadFile(file.fileId, file.fileName)"><mat-icon>download</mat-icon></button>
                          </div>
                      </div>
                  </li>
              </ul>
              <ul class="list-group
              list-group-flush" *ngIf="fileDetailsScan.length == 0">
                  <li class="list-group item">
                      <div class="d-flex justify-content-between">
                          <div>No Scan Files Uploaded</div>
                      </div>
                  </li>
              </ul>
            </div> -->
<!-- <div class="card">
              <div class="card-header d-flex justify-content-between">
                  <div>Design Files</div>
              </div>
              <ul class="list-group list-group-flush" *ngFor="let file of fileDetailsDesign">
                  <li class="list-group item">
                      <div class="d-flex justify-content-between">
                          <div>{{file.fileName}}</div>
                          <div class="align-content-center">
                              <button mat-icon-button *ngIf="dataService.role == 'designer'" (click)="removeFileDetails(file.fileId)"><mat-icon>delete</mat-icon></button>
                              <button mat-icon-button (click)="downloadFile(file.fileId, file.fileName)"><mat-icon>download</mat-icon></button>
                          </div>
                      </div>
                  </li>
              </ul>
              <ul class="list-group list-group-flush" *ngIf="fileDetailsDesign.length == 0">
                  <li class="list-group item">
                      <div class="d-flex justify-content-between">
                          <div>No Design Files Uploaded</div>
                      </div>
                  </li>
              </ul>
            </div> -->
<!-- </div>
    </div>
</div> -->
<!-- 
<mat-dialog-content class="mat-typography">
    <mat-card-content>
        <div class="card mb-4">
            <div class="card-header d-flex justify-content-between">
              <div>Scan Files</div>
            </div>
            <ul class="list-group list-group-flush" *ngFor="let file of fileDetailsScan">
              <li class="list-group-item">
                <div class="d-flex justify-content-between">
                  <div>{{file.fileName}}</div>
                  <div class="align-content-center">
                    <button *ngIf="dataService.role == 'doctor'" mat-icon-button (click)="removeFileDetails(file.fileId)"><mat-icon>delete</mat-icon></button>
                    &nbsp;
                      <button mat-icon-button (click)="downloadFile(file.fileId, file.fileName)"><mat-icon>download</mat-icon></button>
                  </div>
                </div>
              </li>
            </ul>
            <ul class="list-group list-group-flush" *ngIf="fileDetailsScan.length == 0">
              <li class="list-group-item">
                <div class="d-flex justify-content-between">
                  <div>No Scan Files Uploaded</div>
                </div>
              </li>
            </ul>
        </div>

        <div class="card mb-4">
            <div class="card-header d-flex justify-content-between">
              <div>Design Files</div>
            </div>
            <ul class="list-group list-group-flush" *ngFor="let file of fileDetailsDesign">
              <li class="list-group-item">
                <div class="d-flex justify-content-between">
                  <div>{{file.fileName}}</div>
                  <div class="align-content-center">
                    <button mat-icon-button *ngIf="dataService.role == 'designer'" (click)="removeFileDetails(file.fileId)"><mat-icon>delete</mat-icon></button>
                    <button mat-icon-button (click)="downloadFile(file.fileId, file.fileName)"><mat-icon>download</mat-icon></button>
                  </div>
                </div>
              </li>
            </ul>
            <ul class="list-group list-group-flush" *ngIf="fileDetailsDesign.length == 0">
              <li class="list-group-item">
                <div class="d-flex justify-content-between">
                  <div>No Design Files Uploaded</div>
                </div>
              </li>
            </ul>
          </div>
    </mat-card-content>
</mat-dialog-content>

<mat-dialog-actions align="start">
    <div class="d-flex" style="width: -webkit-fill-available;">
        <div>
            <button  class="customPreActivatedButtons" (click)="customFile.click()"><mat-icon>upload</mat-icon>Upload</button>
            <input hidden multiple (change)="addFileDetails($event)" #customFile type="file" id="customFile">
        </div>
        <div><button mat-icon-button (click)="ngOnInit()"><mat-icon>close</mat-icon></button></div>
    </div>
</mat-dialog-actions> -->

<!-- <div>
  <button mat-icon-button (click)="ngOnInit()"><mat-icon>close</mat-icon></button>
</div> -->